module.exports = __webpack_public_path__ + "media/images/games/35gender/remotecontrolcars-2aed3bd983b3504befe856d8a315b70c.png";